import { render, staticRenderFns } from "./SpecialReportsManager.vue?vue&type=template&id=3fc84b34&scoped=true&"
import script from "./SpecialReportsManager.vue?vue&type=script&lang=js&"
export * from "./SpecialReportsManager.vue?vue&type=script&lang=js&"
import style0 from "./SpecialReportsManager.vue?vue&type=style&index=0&id=3fc84b34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc84b34",
  null
  
)

export default component.exports